export default __webpack_public_path__ + "static/media/skill.9bb32ffb.jpg";